import { useCallback, useContext, useState } from 'react';
import pluralize from 'pluralize';
import { DashboardContext } from '@layouts/DashboardLayout';
import TriggerCTAButton from '@components/UserWorkflowSteps/TriggerCTAButton';
import { getUrl, IDENTIFIERS } from '@helpers/urlsHelper';
import classes from '../UserWorkflowInfo.module.scss';
import DocumentsListViewModal from './DocumentsListViewModal';

type Props = {
  creatorSlug: string;
  compiledDocuments: Parameters<typeof DocumentsListViewModal>[0]['compiledDocuments'];
  onGeneratePdfs: Parameters<typeof TriggerCTAButton>[0]['onClick'];
  userWorkflowId: string;
  generatePdfsTrigger?: Parameters<typeof TriggerCTAButton>[0]['step'] | null;
};

const DocumentsAction: React.FC<Props> = ({
  creatorSlug,
  compiledDocuments,
  onGeneratePdfs,
  generatePdfsTrigger,
  userWorkflowId,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { isInDashboard } = useContext(DashboardContext);
  const canEdit = isInDashboard;

  const documentsHref = canEdit ? getUrl(IDENTIFIERS.DASHBOARD_USER_WORKFLOW_DOCUMENTS, { userWorkflowId }) : '#';

  const handleClick = (): void => {
    if (!canEdit) {
      setIsModalOpen(true);
    }
  };

  const handleCloseModal = useCallback(() => {
    setIsModalOpen(false);
  }, []);

  return (
    <>
      <div className={classes.workflowExtraInfo_text}>
        <p className={classes['workflow-name']}>Documents</p>
        <div className={classes.workflowExtraInfo_documentsActions}>
          {compiledDocuments.length !== 0 && (
            <a
              className="caption-bold"
              onClick={handleClick}
              href={documentsHref}
            >
              {pluralize('file', compiledDocuments.length, true)}
            </a>
          )}
          {generatePdfsTrigger && (
            <>
              {compiledDocuments.length !== 0 && <>·</>}
              <TriggerCTAButton
                className={classes.workflowExtraInfo_generateButton}
                step={generatePdfsTrigger}
                isCreatorView={isInDashboard}
                onClick={onGeneratePdfs}
                buttonText={'Generate PDFs'}
              />
            </>
          )}
        </div>
      </div>
      {isModalOpen && !canEdit && (
        <DocumentsListViewModal creatorSlug={creatorSlug} compiledDocuments={compiledDocuments} onClose={handleCloseModal} />
      )}
    </>
  );
};

export default DocumentsAction;
